import { estimate, type Measure } from './layout.ts';

let ctx: CanvasRenderingContext2D | null | undefined;
let fonts: { sans: string; mono: string } | undefined;
/** Text widths with the page's own fonts (a canvas), so the layout wraps labels exactly as they render. */
export const measure: Measure = (text, f) => {
  if (ctx === undefined) {
    try {
      ctx = document.createElement('canvas').getContext('2d');
    } catch {
      ctx = null;
    }
  }
  if (!ctx) return estimate(text, f);
  fonts ??= {
    sans: getComputedStyle(document.documentElement).getPropertyValue('--font').trim() || 'sans-serif',
    mono: getComputedStyle(document.documentElement).getPropertyValue('--mono').trim() || 'monospace',
  };
  ctx.font = `${f.weight} ${f.size}px ${f.mono ? fonts.mono : fonts.sans}`;
  return ctx.measureText(text).width;
};
